<template>
    <transition name="fade">
        <div
            class="modal"
            :class="value ? 'show' : 'hide'"
            :style="value ? 'display:block;background-color:#3333337a;' : 'display:none;'"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex flex-row align-items-center">
                    <h3>
                        Questionnaire #{{ row_ed.ed_id }}
                    </h3>
                </div>
                <div class="modal-body">
    
                    <div class="row">

                        <div class="col-12 col-lg-6">

                            <h4>Information</h4>
                            <table class="table table-sm">
                                <tbody>
                                    <!--tr>
                                        <td class="text-right no_label_cell">Commande du&nbsp;:</td>
                                        <td>
                                            <span>
                                                {{ $moment(row_ed.createdAt).format("DD/MM/YYYY HH:mm") }}
                                            </span>
                                        </td>
                                    </tr-->
                                    <tr>
                                        <td class="text-right no_label_cell">Contact&nbsp;:</td>
                                        <td>
                                            <a href="javascript: void" @click="goToContactDetails">
                                                {{ row_ed.co_id.co_invoice_firstname }} {{ row_ed.co_id.co_invoice_name }}
                                            </a>
                                            <div>
                                                <small>
                                                    <a :href="$Utils.formatPhoneNumber(row_ed.co_id.co_invoice_tel, row_ed.co_id.co_invoice_country).getURI()">
                                                        {{ $Utils.formatPhoneNumber(row_ed.co_id.co_invoice_tel, row_ed.co_id.co_invoice_country).formatInternational() }}
                                                    </a>
                                                </small>
                                            </div>
                                            <div>
                                                <small>
                                                    <a :href="`mailto:${row_ed.co_id.co_invoice_email}`">
                                                        {{ row_ed.co_id.co_invoice_email }}
                                                    </a>
                                                    </small>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right no_label_cell">Bénéficiaire&nbsp;:</td>
                                        <td>
                                            <a href="javascript: void" @click="goToBoxDetails">
                                                {{ row_ed.en_id ? row_ed.en_id.en_fullname : "---" }}
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right no_label_cell">
                                            Mis à jour le&nbsp;:
                                        </td>
                                        <td>
                                            {{ $moment(row_ed.no_status_date).format("DD/MM/YYYY HH:mm") }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <div class="col-12 col-lg-6">
                            <h4>{{ row_ed.ed_label }}</h4>


                            <div v-for="(item, index) in row_ed.ed_data" :key="index" class="mt-2 mb-2 pl-3">
                                <div><strong>{{item.label}} :</strong></div>
                                <div>- {{item.value}}</div>
                            </div>

                        </div>
                    </div>
                  
            
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="cancelWin">Fermer</button>
                </div>
            </div>
        </div>
        <m-message-dialog v-model="dialogErr" title="Erreur" :text="dialogErrTxt"></m-message-dialog>
        </div>
    </transition>
</template>

<script>
export default {
    name: "formWinEdit",

    components: {},

    props: {
        value: {
            default: false,
            type: Boolean
        },

        row_ed_p: {
            default: null,
            type: Object
        }
    },

    data() {
        return {
            row_ed: {
                co_id: {},
                en_id: {},
                ed_id: undefined,
            },
        };
    },

    mounted() {
        this.user = this.$store.state.user;
        window.addEventListener("keyup", this.onKeyup);
    },

    destroyed() {
        window.removeEventListener("keyup", this.onKeyup);
    },

    created() {},

    watch: {
        row_ed_p(value) {
            this.row_ed = value;
        }
    },

    methods: {

        onKeyup(e) {
            if (e.key === "Escape") {
                this.cancelWin();
            }
        },

        goToContactDetails() {
            this.$router.push(`/contacts/${this.row_ed.co_id.co_id}/details`);
            this.$emit("input", false);
        },
       

        goToBoxDetails() {
            this.$router.push(`/boxes/${this.row_ed.en_id.en_id}`);
            this.$emit("input", false);
        },

        cancelWin() {
            this.comment = "";
            this.status = "";
            this.attachment = "";
            this.$emit("input", false);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "../scss/styles.scss";

    .table {
        table-layout: fixed;
    }

    .table tr:nth-child(odd) {
        background-color: inherit;
    }

    .table tr:hover {
        background-color: inherit;
        cursor: inherit;
    }

    .table tr td {
        border: 0;
    }

    .no_label_cell {
        width: 160px;
        font-weight: 500;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin-bottom: 3px;
        padding: 2px 4px;
        width: 100%;
        cursor: pointer;
        border: 1px solid #c0c0c0;
        border-radius: 3px;
    }

    li:hover {
        background-color: #f5f5f5
    }

    pre {
        white-space: break-spaces;
    }
</style>
